import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errorMessage = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return e?.message || fallback;
};

const GUEST_ROUTES = { "/compile": "/compile/guest", "/legacy/convert": "/legacy/convert" };

// Used without an account: sending setups to the hub and reading old saves are allowed.
export const guestApi = {
  post: async (path, data) => (await axios.post(`${API}${GUEST_ROUTES[path]}`, data)).data,
};

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const call = async (method, path, data) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    };
    return {
      get: (p) => call("get", p),
      post: (p, d) => call("post", p, d),
      put: (p, d) => call("put", p, d),
      patch: (p, d) => call("patch", p, d),
      del: (p) => call("delete", p),
    };
  }, [getToken]);
}
